import APicker from './Picker.vue';
export default APicker;


// WEBPACK FOOTER //
// ./src/packages/Picker/index.js